const parntershipSection = $('#partnership-section');
const parntershipDescriptorCards = parntershipSection.find('.descriptor-card');
const parntershipContent = parntershipSection.find('.partnership-section-content');
const parntershipPhotosParent = parntershipContent.find('.partnership-points-images-parent');
const parntershipPhotosOverflow = parntershipContent.find('.partnership-points-images');
const parntershipPhotos = parntershipContent.find('.partnership-point-image-overflow');
const partnershipPoints = parntershipContent.find('.partnership-point-parent');
const partnershipPointsLines = parntershipContent.find('.partnership-line-inner');
const parntershipPointsIcons = parntershipContent.find('.partnership-point-icon');
let lastHovered = null;
let isPhotosHidden = true;
const parntershipContentWidth = parntershipContent.width();
const leftMenuWidth = $('.partnership-point-content').width() + $('.partnership-point-text').width();
const imageOffsetAspect = leftMenuWidth / parntershipContentWidth;

const initMouseFollower = (parentContainer, container, imageOffsetAspect = 0.2) => {
  let parentWidth, parentHeight, rect, containerWidth, containerHeight;

  const recalcMetrics = () => {
    parentWidth = parentContainer.width();
    parentHeight = parentContainer.height();
    rect = parentContainer.get(0).getBoundingClientRect();
    containerWidth = container.outerWidth();
    containerHeight = container.outerHeight();
  };

  recalcMetrics();
  $(window).on('resize', recalcMetrics);

  return (duration = 0.3) => {
    rect = parentContainer.get(0).getBoundingClientRect();
    const x = clientX - rect.left;
    const y = clientY - rect.top;

    if (x > 0 && x <= parentWidth && y > 0 && y <= parentHeight) {
      const minX = parentWidth * imageOffsetAspect;
      const maxX = parentWidth - containerWidth;
      const containerXOffset = gsap.utils.mapRange(0, parentWidth, minX, maxX, x, true);
      const containerYOffset = y - containerHeight / 2;
      gsap.to(container, {
        x: containerXOffset,
        y: containerYOffset,
        duration,
        overwrite: 'auto',
      });
    }
  };
};

const updateOnMouseMove = initMouseFollower(parntershipContent, parntershipPhotosOverflow, imageOffsetAspect);

const addPartnreshipPhotoAnimation = (index) => {
  const point = partnershipPoints.eq(index);
  const photo = parntershipPhotos.eq(index + 1);
  const prevLine = partnershipPointsLines.eq(index);
  const currLine = partnershipPointsLines.eq(index + 1);
  ScrollTrigger.create({
    trigger: point,
    start: 'top center',
    end: 'bottom center',
    onUpdate: (self) => {
      const progress = self.progress;
      gsap.set(photo, {
        y: `${(1 - progress) * 100}%`,
      });
      gsap.set(prevLine, {
        width: `${(1 - progress * 2) * 100}%`,
      });
      if (progress < 0.5) {
        gsap.set(currLine, {
          width: `0%`,
        });
      } else {
        gsap.set(prevLine, {
          width: `0%`,
        });
        gsap.set(currLine, {
          width: `${(progress - 0.5) * 2 * 100}%`,
        });
      }
    },
  });
};

const hoverPointAnimation = (index, hovered) => {
  const pointLine = partnershipPointsLines.eq(index);
  const pointIcon = parntershipPointsIcons.eq(index);
  gsap.to(pointLine, {
    width: hovered ? 0 : '100%',
    duration: 0.3,
  });
};

const changeCardPhotoAnimation = (index) => {
  const prevPhoto = parntershipPhotos.eq(lastHovered);
  const currPhoto = parntershipPhotos.eq(index);
  const direction = index > lastHovered;
  gsap.to(prevPhoto, {
    y: direction ? '-20%' : '100%',
    duration: 0.3,
  });
  gsap.to(currPhoto, {
    y: 0,
    duration: 0.3,
  });
  hoverPointAnimation(lastHovered, true);
  hoverPointAnimation(index, false);
};

const changeOverflowVisability = (direction) => {
  gsap.to(parntershipPhotosOverflow, {
    scale: direction ? 1 : 0.2,
    opacity: direction ? 1 : 0,
    duration: 0.3,
    overwrite: 'auto',
  });
};

const checkIsPointHovered = () => {
  const contentOffsetTop = parntershipContent.offset().top - $(window).scrollTop();
  const contentHeight = parntershipContent.outerHeight();
  const contentOffsetBottom = contentOffsetTop + contentHeight;

  if (contentOffsetTop <= clientY && contentOffsetBottom >= clientY) {
    updateOnMouseMove(0.5);
  }
  if (contentOffsetTop <= clientY && contentOffsetBottom >= clientY && isPhotosHidden) {
    changeOverflowVisability(true);
  } else {
    hoverPointAnimation(lastHovered, true);
    changeOverflowVisability(false);
    lastHovered = null;
  }
  partnershipPoints.each(function (index) {
    const point = $(this);
    const pointOffsetTop = point.offset().top - $(window).scrollTop();
    const pointHeight = point.outerHeight();
    const pointOffsetBottom = pointOffsetTop + pointHeight;
    if (pointOffsetTop <= clientY && pointOffsetBottom >= clientY && index != lastHovered) {
      if (lastHovered != null) {
        changeCardPhotoAnimation(index);
      } else {
        hoverPointAnimation(index, false);
      }
      lastHovered = index;
    }
  });
};

const addCardPhotoAnimation = () => {
  let isOverflowVisible = false;
  parntershipContent.on('mouseenter', function () {
    changeOverflowVisability(true);
  });
  parntershipContent.on('mouseleave', function () {
    changeOverflowVisability(false);
    hoverPointAnimation(lastHovered, true);
  });
  parntershipContent.on('mousemove', function () {
    updateOnMouseMove(0.5);
  });

  parntershipContent.on('mouseleave', () => (lastHovered = null));
  partnershipPoints.each(function (index) {
    $(this).on('mouseenter', function () {
      if (lastHovered != null) {
        changeCardPhotoAnimation(index);
      } else {
        hoverPointAnimation(index, false);
      }
      lastHovered = index;
    });
  });

  ScrollTrigger.create({
    trigger: parntershipContent,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => {},
    onUpdate: (self) => {
      checkIsPointHovered();
    },
  });
};

const educatorsImagesSet = () => {
  gsap.set(parntershipPhotosOverflow, { opacity: 0 });
};
